// ARCA-152 — terminal `_score_reveal` sidecar atom.
//
// The match-end "score reveal" payload arrives as a sidecar field on the
// TURN_APPLIED frame's `your_state_json` (alongside, but NOT part of, the
// PlayerView), mirroring the `_affinity_reveal` sidecar. The ws-client strips
// the sidecar BEFORE casting the rest as PlayerView and pushes the payload into
// this atom; WinOverlay subscribes via `useStore($scoreReveal)`.
//
// Why a separate atom (vs. extending PlayerView):
// - Sidecar payload is terminal-only — it lives on the FINAL frame, never on
//   intermediate snapshots. Pushing it through PlayerView would pollute the
//   schema with a field that's null 99% of the time.
// - B12 firewall: the opponent's running word score is hidden mid-match, so it
//   must NOT sit on PlayerView. The sidecar lives outside the PlayerView
//   surface entirely (same rationale as affinityReveal.ts).
// - Single-consumer: only WinOverlay needs this payload.

import { atom } from 'nanostores'

export interface ScorePlayerSummary {
  /** Cumulative word score for the slot (Σ per-turn wordScore). */
  readonly score: number
  /** Chess pieces this slot has captured. */
  readonly captures: number
}

export interface ScoreReveal {
  /** Player A's (slot 0) final score + captures. */
  readonly a: ScorePlayerSummary
  /** Player B's (slot 1) final score + captures. */
  readonly b: ScorePlayerSummary
}

export const $scoreReveal = atom<ScoreReveal | null>(null)
